<script setup>
  import { ref } from 'vue'
  import { useLocalePath } from '#i18n'
  import { useMainMenuIrol } from '@/composables/useMainMenuIrol'

  const isOpen = ref(false)
  const localePath = useLocalePath()
  const { menuIrol } = useMainMenuIrol()

  const toggleMenu = () => {
    isOpen.value = !isOpen.value
    if (isOpen.value) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }

  const closeMenu = () => {
    isOpen.value = false
    document.body.style.overflow = 'auto'
  }
</script>

<template>
  <div class="md:hidden">
    <!-- Bouton Burger -->
    <button
      class="flex items-center justify-center w-9 h-9 rounded-full bg-sky-900 hover:bg-sky-700 transition-colors duration-300 focus:outline-none focus:ring-sky-500"
      :aria-expanded="isOpen"
      @click="toggleMenu"
    >
      <div class="relative w-5 h-5">
        <span
          class="absolute top-1/2 left-1/2 block w-5 h-[2px] bg-white rounded-full transition-all duration-300 -translate-x-1/2"
          :class="{ 'rotate-45 -translate-y-1/2': isOpen, '-translate-y-[8px]': !isOpen }"
        ></span>
        <span
          class="absolute top-1/2 left-1/2 block w-5 h-[2px] bg-white rounded-full transition-all duration-300 -translate-x-1/2 -translate-y-1/2"
          :class="{ 'opacity-0 scale-0': isOpen }"
        ></span>
        <span
          class="absolute top-1/2 left-1/2 block w-5 h-[2px] bg-white rounded-full transition-all duration-300 -translate-x-1/2"
          :class="{ '-rotate-45 -translate-y-1/2': isOpen, 'translate-y-[6px]': !isOpen }"
        ></span>
      </div>
    </button>

    <div
      class="fixed inset-0 z-40 transition-opacity duration-300 mt-[calc(var(--header-height)-0.5px)]"
      :class="{ 'opacity-100 visible': isOpen, 'opacity-0 invisible': !isOpen }"
    >
      <!-- Overlay -->
      <div class="absolute inset-0 bg-black/50" @click="closeMenu"></div>

      <!-- Menu -->
      <div
        class="absolute right-0 top-0 h-[calc(100vh-var(--header-height))] w-80 bg-white shadow-lg transform transition-transform duration-300"
        :class="{ 'translate-x-0': isOpen, 'translate-x-full': !isOpen }"
      >
        <div class="p-4 h-full overflow-y-auto">
          <nav class="space-y-4">
            <template v-for="(section, key) in menuIrol" :key="key">
              <div class="border-b border-gray-100 pb-4">
                <h3 class="text-lg font-semibold text-sky-900 mb-3">
                  {{ section.title }}
                </h3>
                <div class="space-y-2">
                  <NuxtLink
                    v-for="item in section.items"
                    :key="item.title"
                    :to="localePath({ name: item.path, params: item.params || {} })"
                    class="flex items-center p-2 rounded-lg hover:bg-gray-50 transition-colors"
                    @click="closeMenu"
                  >
                    <font-awesome
                      :icon="['fas', item.icon]"
                      class="w-5 h-5 mr-3"
                      :class="[item.iconCss.split(' ')[0]]"
                    />
                    <span class="text-gray-700">{{ item.title }}</span>
                  </NuxtLink>
                </div>
              </div>
            </template>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>
